/* eslint-disable react/no-unescaped-entities */
import { useNavigate } from 'react-router-dom';
import { Button, Flex, HStack, Image, Text, VStack } from '@chakra-ui/react';
//@ts-ignore
import Illustration from '../../../assets/icons/Illustration.svg';
import {
  updateAppActiveStep,
  updateAppType,
} from '../../../redux/appBuilder/stepperDetails';
import { AppType } from '../../../redux/appBuilder/stepperDetails/types';
import { useAppDispatch } from '../../../redux/hooks';

export const HomeDashboard = ({
  heading = "Let's get started!",
  showIllustration = true,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleNext = (appType: AppType) => {
    navigate('/new-application');
    dispatch(updateAppType(appType));
    dispatch(updateAppActiveStep(1));
  };

  return (
    <>
      <Flex
        width="full"
        height="calc(100vh - 100px)"
        justifyContent="center"
        mt={showIllustration ? '-30px' : '-180px'}
        alignItems="center"
      >
        <VStack>
          <Text
            fontFamily="inter"
            fontWeight="bold"
            color="black"
            className={showIllustration ? 'xxx-large-font' : 'xx-large-font'}
          >
            {heading}
          </Text>
          {showIllustration && (
            <Image
              src={Illustration}
              className="dashbaoard-image"
              bgColor="white.700"
              alt="Illustration"
            />
          )}
          <Text fontFamily="inter" color="gray" className="x-small-font">
            Where do you want to integrate Reclaim Protocol?
          </Text>
          <HStack m="40px">
            <Button
              className="dashboard-button"
              _hover={{ bgColor: 'gray.800' }}
              onClick={() => handleNext('MOBILE')}
            >
              <Text fontFamily="inter" color="white" className="medium-font">
                Mobile App
              </Text>
            </Button>
            <Button
              className="dashboard-button"
              _hover={{ bgColor: 'gray.800' }}
              onClick={() => handleNext('WEB')}
            >
              <Text fontFamily="inter" color="white" className="medium-font">
                Web App
              </Text>
            </Button>
            <Button
              className="dashboard-button"
              _hover={{ bgColor: 'gray.800' }}
              onClick={() => handleNext('ZK_FETCH')}
            >
              <Text fontFamily="inter" color="white" className="medium-font">
                zkFetch App
              </Text>
            </Button>
            <Button
              className="dashboard-button"
              _hover={{ bgColor: 'gray.800' }}
              onClick={() => handleNext('BC_APP')}
            >
              <Text fontFamily="inter" color="white" className="medium-font">
                BlueCheck App
              </Text>
            </Button>
          </HStack>
        </VStack>
      </Flex>
    </>
  );
};
